import request from '@/service/lib/request'

export function devs() {
  return request({
    url: `/api/v2/preview/devices`,
    method: 'GET'
  })
}

export function imgs(params) {
  return request({
    url: '/api/v2/preview/imgs',
    method: 'get',
    params
  })
}
